// Mapping keyboard keys to their numerical values
export const keyCodes = {
    tab: 9,
    enter: 13,
    esc: 27,
    up: 38,
    down: 40
};
